import type { FC } from "react";

import type { BuilderBlock, BuilderContextInterface, RegisteredComponents } from "@builder.io/sdk-react";
import { Blocks, isEditing } from "@builder.io/sdk-react";

import { QueryClient, QueryClientProvider } from "@jti/rest-api";
import { LoyaltyContactForm as LoyaltyContactFormUI } from "@jti/ui/components/LoyaltyContactForm/LoyaltyContactForm";

import type { loyaltyContactFormInputs } from "./LoyaltyContactForm.builder";

export type LoyaltyContactFormProps = BuilderComponentProps<typeof loyaltyContactFormInputs> & {
  builderBlock: BuilderBlock;
  builderContext: BuilderContextInterface;
  builderComponents: RegisteredComponents;
};

const client = new QueryClient();

export const LoyaltyContactForm: FC<LoyaltyContactFormProps> = ({
  builderBlock,
  builderContext,
  builderComponents,
  title,
  description,
  disclaimer,
  hiddenFields,
  errorMessage,
  successScreenTitle,
  successScreenButtonLabel,
  successScreenHref,
  oneTrust,
  content,
  theme,
  image,
  successFormHeading,
  successFormSubHeading,
  successHeading,
  successScreenDescription,
  successSubHeading,
  sendButtonLabel,
  contestId,
}) => {
  const { consent } = oneTrust;
  const { rightImage } = image;

  const { heading, subHeading } = content;

  return (
    <QueryClientProvider client={client}>
      <LoyaltyContactFormUI
        isInEditor={isEditing()}
        title={title}
        serverErrorMessage={errorMessage}
        description={description}
        formDisclaimer={disclaimer}
        hiddenFields={hiddenFields}
        successScreenTitle={successScreenTitle}
        successScreenButtonLabel={successScreenButtonLabel}
        successScreenHref={successScreenHref}
        consent={consent}
        heading={heading}
        subHeading={subHeading}
        theme={theme}
        imageSrc={rightImage}
        successFormHeading={successFormHeading}
        successFormSubHeading={successFormSubHeading}
        successHeading={successHeading}
        successScreenDescription={successScreenDescription}
        successSubHeading={successSubHeading}
        sendButtonLabel={sendButtonLabel}
        contestId={contestId}
      >
        {builderBlock?.children?.map((child) => (
          <Blocks
            key={child.id}
            blocks={[child]}
            parent={builderBlock?.id}
            path="children"
            context={builderContext}
            registeredComponents={builderComponents}
          />
        ))}
      </LoyaltyContactFormUI>
    </QueryClientProvider>
  );
};
